import AdminWalletDTO from "../shared/dtos/adminWalletDTO";
import axiosInstance from "../app/axios";

export const createAdminWallet = async (
  id: number,
  adminWallet: AdminWalletDTO,
) => {
  return await axiosInstance.post(`adminwallet/${id}`, adminWallet);
};

export const getAdminWalletByAdminId = async (id: number) => {
  return await axiosInstance.get(`adminwallet/balance/${id}`);
};
